import { SEO } from "@/components/seo";
import { organizationJsonLd, websiteJsonLd } from "@/lib/seo/jsonld";
import { Navbar } from "@/components/navbar";
import { HeroSection } from "@/components/hero-section";
import { LogoTicker } from "@/components/logo-ticker";
import { WhyHarmCheck } from "@/components/why-harmcheck";
import { StakesSection } from "@/components/stakes-section";
import { DashboardPreview } from "@/components/dashboard-preview";
import { Classifiers } from "@/components/classifiers";

import { WhyNotKeywords } from "@/components/why-not-keywords";
import { Testimonials } from "@/components/testimonials";
import { TrustSecurity } from "@/components/trust-security";
import { CTASection } from "@/components/cta-section";
import { Footer } from "@/components/footer";

export function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans overflow-x-hidden">
      <SEO
        title="Stop harm before it's sent"
        description="HarmCheck is enterprise communication compliance software that prevents harmful or non-compliant messages before they're sent. Built by Alphy."
        path="/"
        jsonLd={[organizationJsonLd(), websiteJsonLd()]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <LogoTicker />
        <WhyHarmCheck />
        <DashboardPreview />
        <Classifiers />
        <StakesSection />

        <WhyNotKeywords />
        <Testimonials />
        <TrustSecurity />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
